import { useEffect, useState } from 'react';
import { CircularProgress, Stack } from '@mui/material';

import { TableBasic } from '../../components/TableBasic';
import { TitlePage } from '../../components/TitlePage';
import { Filter } from './components/Filter';
import useFetch from '../../hooks/useFetch';
import { urlGetClients } from '../../helpers';


export const ClientScreen = () => {

    const { data } = useFetch(urlGetClients, 'GET', {});

    const [filterArray, setFilterArray] = useState([]);

    const [copyArray, setCopyArray] = useState(data);

    useEffect(() => {
        if (data) {
            setFilterArray(data);
            setCopyArray(data)
        };

    }, [data])

    return (
        <Stack width='100%' alignItems='center' mt='2rem'>
            <Stack width='95%'>
                <TitlePage title={'Clientes'} subtitle={subtitle} buttonTitle={buttonTitle} />
                <Filter filterArray={filterArray} setFilterArray={setFilterArray} copyArray={copyArray} />
                {
                    data
                        ? <TableBasic setCopyArray={setCopyArray} rows={filterArray} setFilterArray={setFilterArray} tableTitle={tableTitle} colNames={colNames} values={values} />
                        : <CircularProgress />
                }

            </Stack>
        </Stack>
    );
}

const colNames = ['Empresa', 'Teléfono', 'Email', 'Móvil', 'CIF/NIF', 'Dirección', ''];

// nombres de los campos de la tabla, importante el primero poner uno de ref de la tabla porque es el valor que vamos a usar para la columna editar y eliminar

const values = ['name', 'tel', 'email', 'movil', 'cif', 'address'];

const subtitle = 'Consulte datos de todos los clientes';
const buttonTitle = 'Nuevo cliente';
const tableTitle = 'client';